var _defs, _path, _line, _line2, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBecksIconsCmsPlatedClassics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.58,38.91c12.34,0,22.34,10,22.34,22.34s-10,22.34-22.34,22.34-22.34-10-22.34-22.34"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.62,
    y1: 45.78,
    x2: 20.62,
    y2: 28.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.49,
    y1: 28.6,
    x2: 27.49,
    y2: 45.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.74,28.6v20.62c0,3.8,3.08,6.87,6.87,6.87h0v34.37c0,1.9,1.54,3.44,3.44,3.44h0c1.9,0,3.44-1.54,3.44-3.44V56.09h0c3.8,0,6.87-3.08,6.87-6.87V28.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.79,54.13c0,7.08,2.77,13.25,6.87,16.57v19.77c0,1.9,1.54,3.44,3.44,3.44s3.44-1.54,3.44-3.44V28.6c-7.59,0-13.75,11.43-13.75,25.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.79,54.13c0-4.22,.56-8.19,1.54-11.7-6.35-10.35-17.72-17.27-30.75-17.27-12.03,0-22.66,5.91-29.21,14.96v9.1c0,3.65-2.86,6.61-6.46,6.83-.25,1.7-.42,3.43-.42,5.2,0,19.93,16.16,36.09,36.09,36.09,17.01,0,31.23-11.78,35.05-27.61-3.52-3.47-5.83-9.14-5.83-15.6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecksIconsCmsPlatedClassics);
export default __webpack_public_path__ + "static/media/BecksIcons_CMS_PlatedClassics.4c122b862aae22332601c83d4975f5bc.svg";
export { ForwardRef as ReactComponent };